import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';

export function initSentry() {
  if (!environment.sentry || !environment.sentry.enabled) {
    console.warn('Sentry is disabled in environment');
    return;
  }

  if (!environment.sentry.dsn || environment.sentry.dsn === 'YOUR_SENTRY_DSN_HERE') {
    console.error('❌ Sentry DSN is not configured properly');
    return;
  }

  try {
    Sentry.init({
      dsn: environment.sentry.dsn,
      environment: environment.sentry.environment,
      debug: true,

      // ⚠️ v5 KHÔNG có tracing
      // tracesSampleRate: 1.0 ❌

      sampleRate: 1.0,

      release: 'cp-cxm-client@1.0.0',

      beforeSend(event, hint) {
        const error = hint && hint.originalException;

        // Ignore ChunkLoadError
        if (error && (error as any).name === 'ChunkLoadError') {
          return null;
        }

        // Ignore 401
        const status =
          event &&
          event.contexts &&
          (event.contexts as any).http_response &&
          (event.contexts as any).http_response.status;

        if (status === 401) {
          return null;
        }

        return event;
      },
    });

    // ✅ Thay cho initialScope
    Sentry.configureScope(scope => {
      scope.setTag('component', 'cp-cxm-client');

      scope.setContext('runtime', {
        name: 'browser',
      });
    });

    console.log('✅ Sentry initialized successfully');
  } catch (error) {
    console.error('❌ Failed to initialize Sentry:', error);
  }
}